import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import Admin from "./pages/Admin.tsx";
import ListingDetail from "./pages/ListingDetail.tsx";
import NotFound from "./pages/NotFound.tsx";
import BarraDaTijuca from "./pages/BarraDaTijuca.tsx";
import CoberturaParqueDasRosas from "./pages/CoberturaParqueDasRosas.tsx";
import Copacabana from "./pages/Copacabana.tsx";
import Ipanema from "./pages/Ipanema.tsx";
import Leblon from "./pages/Leblon.tsx";
import Botafogo from "./pages/Botafogo.tsx";
import Tijuca from "./pages/Tijuca.tsx";
import RecreioDosBandeirantes from "./pages/RecreioDosBandeirantes.tsx";
import Lagoa from "./pages/Lagoa.tsx";
import Flamengo from "./pages/Flamengo.tsx";
import Laranjeiras from "./pages/Laranjeiras.tsx";
import CentroDoRio from "./pages/CentroDoRio.tsx";
import Gloria from "./pages/Gloria.tsx";
import JardimBotanico from "./pages/JardimBotanico.tsx";
import Gavea from "./pages/Gavea.tsx";
import Lancamentos from "./pages/Lancamentos.tsx";
import LaunchDetail from "./pages/LaunchDetail.tsx";
import ResetPassword from "./pages/ResetPassword.tsx";
import ApartHotelLeblon from "./pages/ApartHotelLeblon.tsx";
import ThankYou from "./pages/ThankYou.tsx";
import Blog from "./pages/Blog.tsx";
import BlogPost from "./pages/BlogPost.tsx";
import StudiosAirbnbCopacabana from "./pages/StudiosAirbnbCopacabana.tsx";
import ImoveisLuxoLagoa from "./pages/ImoveisLuxoLagoa.tsx";
import Apartamentos4QuartosIpanema from "./pages/Apartamentos4QuartosIpanema.tsx";
import LagoaVistaHub from "./pages/LagoaVistaHub.tsx";
import IpanemaHub from "./pages/IpanemaHub.tsx";
import Avaliacao from "./pages/Avaliacao.tsx";
import AnuncieSeuImovel from "./pages/AnuncieSeuImovel.tsx";
import CanonicalUpdater from "./components/CanonicalUpdater";
import GlobalWelcomeLead from "./components/GlobalWelcomeLead";
import CookieConsent from "./components/CookieConsent";

import Login from "./pages/Login.tsx";
import OAuthConsent from "./pages/OAuthConsent.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <CanonicalUpdater />
          <GlobalWelcomeLead />
          <CookieConsent />

          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
            <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/barra-da-tijuca" element={<BarraDaTijuca />} />
            <Route path="/barra-da-tijuca/cobertura-3-quartos-barra-parque-das-rosas" element={<CoberturaParqueDasRosas />} />
            <Route path="/copacabana" element={<Copacabana />} />
            <Route path="/ipanema" element={<Ipanema />} />
            <Route path="/leblon" element={<Leblon />} />
            <Route path="/botafogo" element={<Botafogo />} />
            <Route path="/tijuca" element={<Tijuca />} />
            <Route path="/recreio-dos-bandeirantes" element={<RecreioDosBandeirantes />} />
            <Route path="/lagoa" element={<Lagoa />} />
            <Route path="/flamengo" element={<Flamengo />} />
            <Route path="/laranjeiras" element={<Laranjeiras />} />
            <Route path="/centro-do-rio" element={<CentroDoRio />} />
            <Route path="/gloria" element={<Gloria />} />
            <Route path="/jardim-botanico" element={<JardimBotanico />} />
            <Route path="/gavea" element={<Gavea />} />
            <Route path="/avaliacao" element={<Avaliacao />} />
            <Route path="/anuncie-seu-imovel" element={<AnuncieSeuImovel />} />
            <Route path="/lancamentos" element={<Lancamentos />} />
            <Route path="/lancamentos/:slug" element={<LaunchDetail />} />
            <Route path="/leblon/apart-hotel-dias-ferreira" element={<ApartHotelLeblon />} />
            <Route path="/obrigado" element={<ThankYou />} />
            <Route path="/obrigado-agendar-visita" element={<ThankYou />} />
            <Route path="/obrigado-imoveis" element={<ThankYou />} />
            <Route path="/obrigado-bairros" element={<ThankYou />} />
            <Route path="/obrigado-landing-page" element={<ThankYou />} />
            <Route path="/obrigado-avaliacao" element={<ThankYou />} />
            <Route path="/obrigado-anuncie-seu-imovel" element={<ThankYou />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/studios-airbnb-copacabana" element={<StudiosAirbnbCopacabana />} />
            <Route path="/imoveis-de-luxo-na-lagoa" element={<ImoveisLuxoLagoa />} />
            <Route path="/apartamentos-4-quartos-ipanema" element={<Apartamentos4QuartosIpanema />} />
            <Route path="/lagoa/apartamentos-exclusivos-vista-lagoa-rodrigo-de-freitas-rj" element={<LagoaVistaHub />} />
            <Route path="/ipanema/melhores-imoveis-de-ipanema" element={<IpanemaHub />} />
            <Route

              path="/lagoa/apartamento-4-quartos-1-vaga-a-venda-na-lagoa-com-216m"
              element={<Navigate to="/lagoa/apartamento-3-quartos-com-vista-para-a-lagoa-com-216m2" replace />}
            />
            <Route
              path="/ipanema/apartamento-4-quartos-1-vaga-a-venda-na-lagoa-com-216m"
              element={<Navigate to="/lagoa/apartamento-3-quartos-com-vista-para-a-lagoa-com-216m2" replace />}
            />
            <Route path="/imovel/:id" element={<ListingDetail />} />
            <Route path="/:neighborhoodSlug/:slug" element={<ListingDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
